import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box, Typography } from '@mui/material';
import { productsPathTo } from '../utils/Api';
import { CurrencyField, ProductPriceSimulation} from '.';

const ProductPriceChangeDialog = ({ selectedProduct, onClose }) => {
  const [product, setProduct] = useState(selectedProduct);
  
  useEffect(() => {
    setProduct(selectedProduct);
  }, [selectedProduct]);

  const handleSubmit = (e) => {
    e.preventDefault();
    productsPathTo.update_price(product.id, { price: product.price }).then((result) => {
      onClose(result.data);
    });
  }
  
  if(!product) {
    return null;
  }
  
  return (
    <Dialog open={!!selectedProduct} onClose={() => onClose()}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Alterar Preço</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
          <TextField label="Título" name="title" disabled variant="outlined" type="text" value={product.title} fullWidth sx={{ marginTop: '8px' }}/>
          <br/>
          <CurrencyField 
            value={product.price}
            fieldSelect={true}
            onChange={(price) => setProduct({ ...product, price: price })}
          />

          <ProductPriceSimulation product={product} />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" type="button" onClick={() => onClose()}>Cancelar</Button>
          <Button variant="contained" type="submit">Confirmar</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ProductPriceChangeDialog;